import React, { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
 
const Footer = () => {
  const [showContact, setShowContact] = useState(false);
 
  return (
    <footer className="bg-[#1a1a1a] text-gray-200 text-sm mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 space-y-6">
        {/* Top links */}
        <div className="flex flex-col md:flex-row md:justify-between items-center text-center md:text-left border-b border-gray-700 pb-6 gap-4">
          <div className="flex flex-wrap items-center justify-center gap-6">
            <button
              onClick={() => setShowContact(!showContact)}
              className="flex items-center gap-2 hover:text-[#FFCC00] focus:outline-none transition-colors duration-200"
            >
              <span></span> Contact Us
            </button>
            <a href="/more-sites" className="hover:text-[#FFCC00] transition-colors duration-200">
              <span></span> More sites
            </a>
            <a href="/coverage-map" className="hover:text-[#FFCC00] transition-colors duration-200">
              <span></span> Coverage map
            </a>
          </div>
 
          {/* Social media icons */}
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-4 text-[#FFCC00] text-lg">
            <a href="https://www.facebook.com/MTNRW/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/mtnrwanda/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaInstagram />
            </a>
            <a href="https://x.com/MTNRwanda" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaTwitter />
            </a>
            <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaWhatsapp />
            </a>
            <a href="https://www.youtube.com/@mtnrw" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/company/mtn-rwanda/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
 
        {/* Expanded contact section (popup) */}
        {showContact && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border border-gray-700 rounded-lg p-6 bg-[#111] text-white animate-fadeIn">
            {/* Left Column */}
            <div className="space-y-6">
              <div className="flex items-start gap-3">
                <FaPhoneAlt className="text-[#FFCC00] mt-1 text-lg" />
                <div>
                  <h4 className="font-semibold">Call Toll Free</h4>
                  <p className="bg-[#FFCC00] text-black inline-block px-2 py-[2px] rounded mt-1 text-sm font-medium">
                    100
                  </p>
                </div>
              </div>
 
              <div className="flex items-start gap-3">
                <FaEnvelope className="text-[#FFCC00] mt-1 text-lg" />
                <div>
                  <h4 className="font-semibold">Rwanda</h4>
                  <p className="bg-[#FFCC00] text-black inline-block px-2 py-[2px] rounded mt-1 text-sm font-medium">
                    customercare.rw@mtn.com
                  </p>
                </div>
              </div>
 
              <div className="flex items-start gap-3">
                <FaEnvelope className="text-[#FFCC00] mt-1 text-lg" />
                <div>
                  <h4 className="font-semibold">Outside Countries</h4>
                  <p className="bg-[#FFCC00] text-black inline-block px-2 py-[2px] rounded mt-1 text-sm font-medium">
                    customerservice.rw@mtn.com
                  </p>
                </div>
              </div>
 
              <div className="flex items-start gap-3">
                <FaEnvelope className="text-[#FFCC00] mt-1 text-lg" />
                <div>
                  <h4 className="font-semibold">General Information</h4>
                  <p className="bg-[#FFCC00] text-black inline-block px-2 py-[2px] rounded mt-1 text-sm font-medium">
                    info@mtn.com
                  </p>
                </div>
              </div>
 
              <div className="flex items-start gap-3">
                <FaEnvelope className="text-[#FFCC00] mt-1 text-lg" />
                <div>
                  <h4 className="font-semibold">Reception Desk</h4>
                  <p className="bg-[#FFCC00] text-black inline-block px-2 py-[2px] rounded mt-1 text-sm font-medium">
                    reception.rw@mtn.com
                  </p>
                </div>
              </div>
            </div>
 
            {/* Right Column */}
            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-[#FFCC00] uppercase mb-2">
                  Physical Address
                </h4>
                <p className="text-gray-300 leading-relaxed">
                  MTN Centre, KG 9 Ave,<br />
                  Kigali
                </p>
              </div>
 
              <div>
                <h4 className="font-semibold text-[#FFCC00] uppercase mb-2">
                  Working Hours
                </h4>
                <p>
                  <span className="font-semibold text-white">Monday – Friday</span><br />
                  <span className="text-[#FFCC00]">8AM – 9PM</span>
                </p>
                <p className="mt-2">
                  <span className="font-semibold text-white">Weekend</span><br />
                  <span className="text-[#FFCC00]">9AM – 5PM</span>
                </p>
              </div>
            </div>
          </div>
        )}
 
        {/* Middle links */}
        <div className="flex flex-wrap justify-center gap-6 text-gray-300 border-t border-gray-700 pt-6">
          <a href="https://www.mtn.co.rw/terms-condtions/" className="hover:text-[#FFCC00] transition-colors duration-200">
            Terms & Conditions
          </a>
          <a href="http://mtn.co.rw/data-protection-and-privacy-notice/" className="hover:text-[#FFCC00] transition-colors duration-200">
            Privacy Policy
          </a>
          <a href="https://www.mtn.co.rw/personal/whistleblowing-policy/" className="hover:text-[#FFCC00] transition-colors duration-200">
            Code of Ethics
          </a>
        </div>
 
        <p className="text-center text-xs text-gray-400 px-4">
          MTN (PTY) LTD is an authorised Financial Service Provider, underwritten
          by Guardrisk Insurance Company. FSP license number: 44774
        </p>
      </div>
    </footer>
  );
};
 
export default Footer;